import { useTranslation } from "react-i18next";
import { UserRole } from "@/types/users";
import type { ITagProps } from "@/ui-kit";
import { Tag } from "@/ui-kit";

type IProps = {
  value: UserRole | null | undefined;
  tagProps?: Partial<ITagProps>;
};

export const useRoleTagMap = () => {
  const { t } = useTranslation();

  const tagPropsMap: Record<UserRole, ITagProps> = {
    [UserRole.Client]: {
      color: "blue-light",
      text: t("label.client"),
    },
    [UserRole.Inspector]: {
      color: "red-light",
      text: t("label.inspector"),
    },
    [UserRole.Contractor]: {
      color: "orange-light",
      text: t("label.contractor"),
    },
    [UserRole.LoanOfficer]: {
      color: "green-light",
      text: t("label.loan_officer"),
    },
    [UserRole.LoanProcessor]: {
      color: "green-light",
      text: t("label.loan_processor"),
    },
    [UserRole.ProjectManager]: {
      color: "magenta-light",
      text: t("label.project_manager"),
    },
    [UserRole.Admin]: {
      color: "purple-light",
      text: t("label.admin"),
    },
    [UserRole.SuperAdmin]: {
      color: "cyan-light",
      text: t("label.super_admin"),
    },
  };

  const getTagProps = (role: UserRole): ITagProps => {
    return tagPropsMap[role] || {};
  };

  return { tagPropsMap, getTagProps };
};

export const UserRoleTag = ({ value, tagProps: _tagProps }: IProps) => {
  const { tagPropsMap } = useRoleTagMap();

  if (!value) {
    return "";
  }

  const tagProps = {
    ...tagPropsMap[value],
    ..._tagProps,
  };

  return tagPropsMap[value] ? <Tag {...tagProps} /> : <Tag text={value} />;
};
